import { Response, httpPost } from "@config/http";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";

const { REACT_APP_BASE_URL } = process.env;

const initialState = {};

const createStripeCheckoutSession = createAsyncThunk(
  "stripe/Create checkout session",
  async () => {
    let results: Response | null;
    try {
      results = await trackPromise(
        httpPost(
          `${REACT_APP_BASE_URL}/api/v1/stripe/checkout-session`,
          {},
          true
        )
      );
      return Promise.resolve(results?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

const settingsSlice = createSlice({
  name: "settings",
  initialState: initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
});

export const settingsReducer = settingsSlice.reducer;

export const settingsActions = {
  ...settingsSlice.actions,
  createStripeCheckoutSession,
};
